const hasDocument = 'document' in globalThis;

export const isServerSide = !hasDocument;
export const isClientSide = hasDocument;
